import { render, staticRenderFns } from "./proposal-search.vue?vue&type=template&id=67307f00"
import script from "./proposal-search.vue?vue&type=script&lang=js"
export * from "./proposal-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports